import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import useInfiniteDataQuery from '../../../hooks/useInfiniteDataQuery/useInfiniteDataQuery';
import { InfiniteDataQueryFnUtils } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { OmitPaginatedEndpointParams } from '../../types';
import { getFindClassificationsKey } from './classifications.keys';
import { findClassifications } from './classifications.repository';
import { FindClassificationsOutput, FindClassificationsParams } from './classifications.types';

export const useFindClassifications = (params: FindClassificationsParams) =>
  useDataQuery<FindClassificationsOutput | null>({
    queryKey: getFindClassificationsKey(params),
    queryFn: async () => {
      const data = await findClassifications(params);

      if (!data.ok || !data.data) {
        return null;
      }

      return data.data;
    },
  });

export const useInfiniteClassificationsList = (
  params: OmitPaginatedEndpointParams<FindClassificationsParams>,
) =>
  useInfiniteDataQuery({
    limit: 20,
    queryKey: ['classifications', 'infinite', params],
    defaultOrderBy: { classificationType: 'ASC' },
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCountAndParams(findClassifications, params),
  });
